import React, { useEffect, useState } from 'react';
import pb from '../lib/pocketbase';
import { useCart } from '../context/CartContext';
import { useFavorites } from '../context/FavoritesContext';
import { useSettings } from '../context/SettingsContext';
import { Link } from 'react-router-dom';
import { Coffee, ShoppingBag, Info, ChevronRight, Heart } from 'lucide-react';
import './NotreCarte.css';

const NotreCarte = () => {
    const [categories, setCategories] = useState([]);
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const { addToCart } = useCart();
    const { toggleFavorite, isFavorite } = useFavorites();
    const { settings } = useSettings();

    useEffect(() => {
        window.scrollTo(0, 0);
        fetchMenu();
    }, []);

    const fetchMenu = async () => {
        try {
            const [catRecords, prodRecords] = await Promise.all([
                pb.collection('categories_carte').getFullList({ sort: '+ordre' }),
                pb.collection('produits_carte').getFullList({
                    sort: '+ordre',
                    filter: 'disponible = true'
                })
            ]);
            setCategories(catRecords);
            setProducts(prodRecords);
        } catch (err) {
            console.error("Error fetching menu:", err);
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <div className="loading-state">Préparation de la carte...</div>;

    return (
        <div className="notre-carte-page">
            <section className="carte-hero section text-center">
                <div className="container animate-fade-in">
                    <span className="section-subtitle">Dégustation & Boutique</span>
                    <h1>Notre Carte</h1>
                    <div className="divider-gold"></div>
                    <p className="hero-description">
                        Découvrez notre sélection de thés d'exception, cafés gourmands, boissons artisanales et douceurs à emporter.
                        Une invitation au voyage au cœur d'Albi.
                    </p>
                </div>
            </section>

            <div className="container">
                {categories.map(category => {
                    const categoryProducts = products.filter(p => p.categorie === category.id);
                    if (categoryProducts.length === 0) return null;

                    return (
                        <section key={category.id} className="menu-category-section section">
                            <div className="category-header">
                                <h2 className="category-title">{category.nom}</h2>
                                <div className="category-line"></div>
                            </div>

                            <div className="menu-grid">
                                {categoryProducts.map(product => (
                                    <div key={product.id} className="menu-item-card">
                                        <div className="menu-item-image">
                                            {product.photo ? (
                                                <img src={pb.files.getURL(product, product.photo, { thumb: '200x200' })} alt={product.nom} />
                                            ) : (
                                                <div className="menu-placeholder"><Coffee size={24} /></div>
                                            )}
                                        </div>
                                        <div className="menu-item-details">
                                            <div className="menu-item-main">
                                                <h3 className="menu-item-name">{product.nom}</h3>
                                                <span className="menu-item-price">{product.prix} €</span>
                                            </div>
                                            <p className="menu-item-desc">{product.description}</p>

                                            <div className="menu-item-footer">
                                                {product.stock <= 0 ? (
                                                    <span className="badge-sold-out">Victime de son succès</span>
                                                ) : settings.isClickCollectDisabled ? (
                                                    <button
                                                        className="btn-add-mini"
                                                        onClick={() => toggleFavorite({
                                                            ...product,
                                                            name: product.nom,
                                                            image: product.photo ? pb.files.getURL(product, product.photo) : null
                                                        })}
                                                        style={{ background: isFavorite(product.id) ? 'var(--color-brown)' : 'transparent', color: isFavorite(product.id) ? 'white' : 'var(--color-brown)', border: '1px solid var(--color-brown)' }}
                                                    >
                                                        <Heart size={14} fill={isFavorite(product.id) ? 'white' : 'none'} /> {isFavorite(product.id) ? 'Retirer' : 'Favoris'}
                                                    </button>
                                                ) : (
                                                    <button
                                                        className="btn-add-mini"
                                                        onClick={() => addToCart({
                                                            ...product,
                                                            name: product.nom,
                                                            image: product.photo ? pb.files.getURL(product, product.photo) : null
                                                        })}
                                                    >
                                                        <ShoppingBag size={14} /> Ajouter
                                                    </button>
                                                )}
                                                {product.afficherStock && product.stock > 0 && product.stock <= (product.lowStockThreshold || 5) && (
                                                    <span className="low-stock-alert">🔥 Plus que {product.stock} !</span>
                                                )}
                                                {product.afficherStock && product.stock > (product.lowStockThreshold || 5) && (
                                                    <span className="stock-info-mini">En stock</span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </section>
                    );
                })}
            </div>

            <section className="carte-info-footer section">
                <div className="container">
                    <div className="info-box-premium">
                        <Info size={24} className="info-icon" />
                        <div>
                            <h4>Informations Dégustation</h4>
                            <p>Tous nos produits sont également disponibles à la dégustation dans notre salon de thé historique à Albi.</p>
                        </div>
                        <Link to="/contact" className="btn-outline" style={{ display: 'inline-flex', alignItems: 'center', gap: '5px' }}>
                            Nous Trouver <ChevronRight size={16} />
                        </Link>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default NotreCarte;
